import { useCallback, useContext, useState } from "react";
import { useLensPlatformClient } from "./useLensPlatformClient";
import { ProfileContext } from "../providers/profile-provider";

export const useAcceptBusinessInvitation = () => {
  const lensPlatformClient = useLensPlatformClient();
  const [invitationError, setInvitationError] = useState<string | null>(null);
  const { profile } = useContext(ProfileContext);
  const acceptBusinessInvitation = useCallback(
    async (businessId: string, invitationId: string) => {
      setInvitationError(null);

      if (profile) {
        try {
          const invitation = await lensPlatformClient.business.acceptInvitation(businessId, invitationId);

          return invitation;
        } catch (error: any) {
          let message = error instanceof Error || error?.message ? error.message : "";

          if (message.startsWith("Unexpected exception")) {
            message = "Something went wrong. Please try again later.";
          }
          setInvitationError(message);

          return null;
        }
      }

      return null;
    },
    [profile, lensPlatformClient.business],
  );

  return {
    acceptBusinessInvitation,
    invitationError,
  };
};
